import { FC, FormEvent, ReactElement } from 'react';

import classNames from 'classnames';

import './RadioItem.scss';

interface RadioItemProps extends Omit<JSX.IntrinsicElements['input'], 'onChange'> {
    label: string;
    onChange: (value: string) => void;
    className?: string;
}

const RadioItem: FC<RadioItemProps> = ({
    label,
    disabled,
    onChange,
    className = '',
    ...radioProps
}): ReactElement => {
    const handleChange = (event: FormEvent<HTMLInputElement>): void => {
        onChange(event.currentTarget.value);
    };

    const radioItemClassNames = classNames('radio-item', {
        'radio-item--is-disabled': disabled,
    }, className);

    return (
        <label data-label={label} className={radioItemClassNames}>
            <div className="radio-item__label-wrapper">
                <input
                    {...radioProps}
                    id={label}
                    type="radio"
                    disabled={disabled}
                    onChange={handleChange}
                    className="radio-item__input"
                />
                <div className="radio-item__box" />

                <span className="radio-item__label">
                    {label}
                </span>
            </div>
        </label>
    );
};

export default RadioItem;
